import DynamicFieldsElementOptions from "./dynamicFieldsElementOptions";
import DynamicInput from "~/models/dynamicInput";
import EndPoint from "../../../../formability/organization_settings/models/connections/endPoint";
import {IApiEndPointOptions} from "~/interfaces/apiEndPointInterfaces";
import { ApiMessageType } from '~/interfaces/dynamicFieldsInterfaces'

export default class ApiEndPointOptions extends DynamicFieldsElementOptions<DynamicInput, {endPoint: EndPoint, apiMessageType: ApiMessageType, objectDynamicInput?: DynamicInput}> implements IApiEndPointOptions {
  getElements: (elementContainer: {endPoint: EndPoint, apiMessageType: ApiMessageType, objectDynamicInput?: DynamicInput}) => DynamicInput[];
  matcher: (element: DynamicInput) => boolean;
  getElementsDefault(container: {endPoint: EndPoint, apiMessageType: ApiMessageType, objectDynamicInput?: DynamicInput}): DynamicInput[] {
    if (container.objectDynamicInput) {
      return container.objectDynamicInput.certificateDynamicInputs
    } else if (container.apiMessageType === 'request') {
      return container.endPoint.certificateDynamicInputs;
    } else {
      return container.endPoint.responseDynamicInputs;
    }
  };
  matcherDefault(element: DynamicInput): boolean {
    return true;
  };

  constructor(config: IApiEndPointOptions = {getElements: null, matcher: null}) {
    super(config);
  }

  matchElements(container: {endPoint: EndPoint, apiMessageType: ApiMessageType}, q: string): DynamicInput[] {
    return this.getElements(container).filter(input => input.name.toLowerCase().match(q) !== null);
  }
}